var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameboardTitleBgUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 49,
    viewBox: "0 0 395 49",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H395L368.81 38.4991C364.341 45.0682 356.911 49 348.966 49H46.0336C38.0887 49 30.6586 45.0682 26.1899 38.4991L0 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameboardTitleBgUpdated);
export default __webpack_public_path__ + "static/media/GameboardTitleBgUpdated.5215c0e765ce4d9bf53db88d10b20afd.svg";
export { ForwardRef as ReactComponent };